import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { User } from "../user/type";

export default function UserDetailButton(props: GridCellParams<User, any>) {
    return <Link component={RouterLink} to={props.row.id}>Detay</Link>
}